var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "url(#paint0_linear_265_1899)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 18.75C16.1836 18.75 14.625 17.1914 14.625 15.25C14.625 13.3359 16.1836 11.75 18.125 11.75C20.0391 11.75 21.625 13.3359 21.625 15.25C21.625 17.1914 20.0391 18.75 18.125 18.75ZM20.5586 19.625C22.582 19.625 24.25 21.293 24.25 23.3164V24.4375C24.25 25.1758 23.6484 25.75 22.9375 25.75H13.3125C12.5742 25.75 12 25.1758 12 24.4375V23.3164C12 21.293 13.6406 19.625 15.6641 19.625H16.1289C16.7305 19.9258 17.4141 20.0625 18.125 20.0625C18.8359 20.0625 19.4922 19.9258 20.0938 19.625H20.5586Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_1899",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c100c57e25866b8b5da3d4925cc9a972.svg";
export { ForwardRef as ReactComponent };